const state = {
  common_ratio: [
    { id: 0, widthRatio: 1, heightRatio: 1},
    { id: 1, widthRatio: 2, heightRatio: 3},
    { id: 2, widthRatio: 3, heightRatio: 2},
    { id: 3, widthRatio: 3, heightRatio: 4},
    { id: 4, widthRatio: 4, heightRatio: 3},
    { id: 5, widthRatio: 9, heightRatio: 16},
    { id: 6, widthRatio: 16, heightRatio: 9}
  ],
  common_size: [
    { id: 0, width: 295, height: 413, label: '一寸'},
    { id: 1, width: 390, height: 567, label: '大一寸'},
    { id: 2, width: 413, height: 531, label: '小二寸'},
    { id: 3, width: 413, height: 579, label: '二寸'},
    { id: 4, width: 1050, height: 1500, label: '五寸'},
    { id: 5, width: 1500, height: 1050, label: '五寸横版'},
  ]
}

export default state



// WEBPACK FOOTER //
// ./src/vue/vuex/state.js